export default __webpack_public_path__ + "static/media/pkslogo.e1c4b4d7.svg";